// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__YlxOA","row":"ProcedureTreatmentSummary_row__2GmxN"};